import Alpine from 'alpinejs';
import { VideoList } from './video_list';

Alpine.data('videoList', () => new VideoList());
